import React, { useState, useEffect } from "react";
import {useSelector, useDispatch} from 'react-redux';
import {
  Grid,
  Button,
} from "@material-ui/core";
import {
  TypographyMui as Typography,
  ButtonTextMUI,
} from "utils/componentsStyle"
import { orange } from "@material-ui/core/colors";
import ModalDialog from "views/Widgets/Common/ModalDialog";
import ModalEditLineaPrefactura from "./ModalEditLineaPrefactura";
import {
  MuiPickersUtilsProvider,
  KeyboardDateTimePicker,
} from "@material-ui/pickers";
import api from "utils/API";
import MomentUtils from "@date-io/moment";
import moment from "moment-timezone";
import TableComponent from "views/Widgets/Common/TableComponent";
import {toMoneyFormat} from "utils/formatFunctions";
import {setmessageGeneral } from "actions/getGlobalAction";
import "moment/locale/es";
moment.locale("es");

export default function ModalQuotationPatient(props) {
  const dispatch = useDispatch();
  const { open, closeModal } = props;
  const [endDateFact, setendDateFact] = useState(moment());
  const [startDateFact, setstartDateFact] = useState(moment().startOf('month'));
  const [minstartDateFact, setminstartDateFact] = useState(null);
  const [prev, setprev] = useState(true);
  const [datosCalculados, setdatosCalculados] = useState(null);
  const [lineaEnEdicion, setlineaEnEdicion] = useState(null);

  const patient = useSelector(state => state.currentGlobalVar.patientClinicOrder);
  const lastFactDate = patient?.facturacion?.fin_periodo ? moment(patient?.facturacion?.fin_periodo) : null


  const fullName = `${patient?.id_paciente?.nombre} ${patient?.id_paciente?.apellido_paterno} ${patient?.id_paciente?.apellido_materno}`


  useEffect(() => {
    if (lastFactDate) {
      setstartDateFact(moment(lastFactDate).add(1, 'days'))
      setminstartDateFact(moment(lastFactDate))
    }
  } , [])

  // Las lineas con "_clave_temporal" son headers internos de tratamiento
  // antibiotico que el backend necesita para vincular padre/hijo al confirmar
  // (ver design.md de este change) -- no se muestran ni se editan.
  const obtenerFilasVisibles = () => {
    if (!datosCalculados) return [];
    const filas = [];
    [
      { grupo: "lineas_cmh", lista: datosCalculados.lineas_cmh || [] },
      { grupo: "lineas_mhs", lista: datosCalculados.lineas_mhs || [] },
    ].forEach(({ grupo, lista }) => {
      lista.forEach((sublista, sublistaIndex) => {
        sublista.forEach((linea, lineaIndex) => {
          if (!linea._clave_temporal) {
            filas.push({ grupo, sublistaIndex, lineaIndex, linea });
          }
        });
      });
    });
    return filas;
  };

  const handleUpdateLinea = (grupo, sublistaIndex, lineaIndex, cantidad, valor) => {
    setdatosCalculados(prevDatos => {
      const tempDatos = { ...prevDatos };
      const tempLista = tempDatos[grupo].map(sublista => [...sublista]);
      const tempLinea = { ...tempLista[sublistaIndex][lineaIndex] };
      tempLinea.cantidad_efectuada_modificado = cantidad;
      tempLinea.valor_unitario_modificado = valor;
      tempLinea.total_prestacion_modificado = cantidad * valor;
      tempLista[sublistaIndex][lineaIndex] = tempLinea;
      tempDatos[grupo] = tempLista;
      return tempDatos;
    });
  };

  const handleFacturate = () => {
    if (prev) {
      const body = {
        id_paciente: patient.id_paciente_id,
        fecha_inicio: startDateFact.format('YYYY-MM-DD HH:mm:00'),
        fecha_fin: endDateFact.format('YYYY-MM-DD HH:mm:00'),
        prev: true,
      }
      api.post(`/api/facturacion/facturar/pacientes/`, body).then(response => {
        setmessageGeneral(dispatch, "Cargando datos para facturar", "success", "Cargar datos");
        setprev(false)
        setdatosCalculados(response.data)
      })
    } else {
      const body = {
        ...datosCalculados,
        prev: false,
      }
      api.post(`/api/facturacion/facturar/pacientes/`, body).then(response => {
        setmessageGeneral(dispatch, "El se ha notificado a los respectivos usuarios sobre el proceso de facturación del paciente", "success", "Facturación iniciada");
        closeModal()
      })
    }

  }

  const attrDatePicker = {}

  if (minstartDateFact){
    attrDatePicker["minDate"] = minstartDateFact
  }


  const handleChangeDate = (value, set) => {
    set(value)
    setprev(true)
    setdatosCalculados(null)
  }

  const filasVisibles = obtenerFilasVisibles();

  const header = [
      {label: "Codigo prestación"},
      {label: "Nombre"},
      {label: "Tipo"},
      {label: "Cantidad"},
      {label: "Valor unitario"},
      {label: "Total"},
      {eval: false, label: ""},
  ]

  const data = filasVisibles.map(({grupo, sublistaIndex, lineaIndex, linea}) => {
    const _editButton_ = <ButtonTextMUI
      style={{ background: orange[500] }}
      className="text-white"
      onClick={() => setlineaEnEdicion({grupo, sublistaIndex, lineaIndex, linea})}
    >
      Editar
    </ButtonTextMUI>

    return [
      {value: linea.codigo_prestacion},
      {value: linea.prestacion_efectuada},
      {value: linea.tipo_prestacion},
      {value: linea.cantidad_efectuada_modificado},
      {value: toMoneyFormat(linea.valor_unitario_modificado)},
      {value: toMoneyFormat(linea.total_prestacion_modificado)},
      {_value_: _editButton_},
    ]
  })

  const _content_ = <Grid
    container
    direction="row"
    justify="center"
    alignItems="center"
    item
    xs={12}
  >
    <Grid
      container
      direction="row"
      justify="center"
      alignItems="center"
      item
      xs={12}
    >
      <Typography variant="body" gutterBottom>
          {`Se va realizar la facturacion del paciente: ${fullName} en el periodo:`}
      </Typography>
    </Grid>
    <Grid
      container
      direction="row"
      justify="center"
      alignItems="center"
      item
      xs={12}
    >
      <Grid
        container
        direction="row"
        justify="center"
        alignItems="center"
        item
        xs={6}
      >
        <MuiPickersUtilsProvider libInstance={moment} utils={MomentUtils}>
            <KeyboardDateTimePicker
                {...attrDatePicker}
                variant="inline"
                format="DD/MM/YYYY HH:mm"
                margin="normal"
                label={"Fecha Inicio"}
                placeholder="Fecha Inicio"
                onChange={(e) => handleChangeDate(e, setstartDateFact)}
                maxDate={moment(endDateFact)}
                value={startDateFact}
                inputVariant={"outlined"}

            />
        </MuiPickersUtilsProvider>
      </Grid>
      <Grid
        container
        direction="row"
        justify="center"
        alignItems="center"
        item
        xs={6}
      >
        <MuiPickersUtilsProvider libInstance={moment} utils={MomentUtils}>
            <KeyboardDateTimePicker
                variant="inline"
                format="DD/MM/YYYY HH:mm"
                margin="normal"
                label={"Fecha Término"}
                placeholder="Fecha Término"
                minDate={moment(startDateFact)}
                maxDate={moment().add(1, 'days')}
                onChange={(e) => handleChangeDate(e, setendDateFact)}
                value={endDateFact}
                inputVariant={"outlined"}
            />
        </MuiPickersUtilsProvider>
      </Grid>
      <Grid
        container
        direction="row"
        justify="center"
        alignItems="center"
        item
        xs={12}
      >
        {filasVisibles.length > 0 &&
         <TableComponent
              headers={header}
              data={data}
          />
        }
      </Grid>
    </Grid>

  </Grid>

  const _actions_ = <>
   <Button
      onClick={handleFacturate}
      color="primary"
      variant="contained"
    >
      {prev ? "Visualizar" : "Facturar"}
    </Button>
   <Button
      onClick={closeModal}
      color="primary"
      variant="contained"
    >
      Cerrar
    </Button>

  </>

  return (
    <>
      <ModalDialog
        open={open}
        onClose={closeModal}
        title={"Facturar paciente"}
        _content_={_content_}
        _actions_ = {_actions_}
        maxWidth={filasVisibles.length > 0 ? "xl" : "sm"}
      />
      {lineaEnEdicion &&
        <ModalEditLineaPrefactura
          open={!!lineaEnEdicion}
          handleClose={() => setlineaEnEdicion(null)}
          linea={lineaEnEdicion.linea}
          onGuardar={(cantidad, valor) => handleUpdateLinea(
            lineaEnEdicion.grupo, lineaEnEdicion.sublistaIndex, lineaEnEdicion.lineaIndex, cantidad, valor
          )}
        />
      }
    </>
  );
}
